import { useQuery } from '@tanstack/react-query';
import { conversations, GetConversationTasksSchema } from '@toggle/toggle';

import { wretchRequest } from '~/utils/api-fetch/apiFetch';

export const QUERY_KEY_CONVERSATION_TASK = 'QUERY_KEY_CONVERSATION_TASK';

export const useConversationTask = (conversationId: string) =>
  useQuery({
    queryKey: [QUERY_KEY_CONVERSATION_TASK, conversationId],
    queryFn: () =>
      wretchRequest<GetConversationTasksSchema>(
        conversations.getConversationTask.path(conversationId),
        {
          schema: conversations.getConversationTask.schema,
        }
      ),
  });
